export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://flowfence.io';

export const SITE = {
  name: 'Flowfence',
  url: SITE_URL,
  title: 'Flowfence — Real-time risk decisioning API',
  description:
    'Catch abuse patterns before they become losses. Flowfence evaluates logins, signups, payments, withdrawals, and API traffic with blocklists, velocity rules, and explainable ALLOW, REVIEW, or BLOCK decisions.',
  keywords: [
    'risk decisioning',
    'fraud detection API',
    'velocity rules',
    'login abuse',
    'signup fraud',
    'payment fraud',
    'API abuse',
    'blocklist',
    'real-time risk engine',
    'transaction monitoring',
  ].join(', '),
  ogImage: `${SITE_URL}/android-chrome-512x512.png`,
  twitterHandle: '',
};

export const SEO_ROUTES = {
  '/': {
    title: SITE.title,
    description: SITE.description,
    path: '/',
    index: true,
  },
  '/login': {
    title: 'Sign in — Flowfence',
    description: 'Sign in to your Flowfence workspace to manage velocity rules, blocklists, and risk decisions.',
    path: '/login',
    index: true,
  },
  '/register': {
    title: 'Start free — Flowfence',
    description:
      'Create a free Flowfence workspace. Define velocity rules, block risky identifiers, and evaluate events with POST /v1/decide.',
    path: '/register',
    index: true,
  },
  '/developers': {
    title: 'API quickstart — Flowfence',
    description:
      'Integrate Flowfence in four steps: get a JWT, create a velocity rule, and call POST /v1/decide. Copy-paste curl and Postman included.',
    path: '/developers',
    index: true,
  },
  default: {
    title: SITE.title,
    description: SITE.description,
    index: false,
  },
};

export const PUBLIC_SITEMAP_PATHS = ['/', '/login', '/register', '/developers'];

export const HOME_JSON_LD = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE.url,
    logo: `${SITE.url}/android-chrome-512x512.png`,
    description: SITE.description,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.name,
    url: SITE.url,
    description: SITE.description,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: SITE.name,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    url: SITE.url,
    description: SITE.description,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    featureList: [
      'Real-time ALLOW, REVIEW, and BLOCK decisions',
      'Velocity rules with COUNT and SUM aggregates',
      'Identifier blocklist fail-fast checks',
      'PII tokenization',
      'Multi-tenant workspaces',
    ],
  },
];
